<template>
  <div fluid style="max-width: 100vw">
    <v-row cols="12" justify="center">
      <p class="head">資料請求</p>
    </v-row>
    <v-row cols="12" justify="center">
      <p class="sub">REQUEST</p>
    </v-row>
    <div class="form" style="max-width: 40vw">
      
        <v-form ref="form" v-model="contactFormValidation.valid" lazy-validation>
          <v-text-field
            v-model="contactForm.corporate"
            :rules="contactFormValidation.requiredRules"
            label="健保名"
            required
            outlined
            solo
          ></v-text-field>
          <!--
          <v-text-field
            v-model="contactForm.department"
            :rules="contactFormValidation.requiredRules"
            label="担当者様名"
            required
            outlined
            solo
          ></v-text-field>
          -->
          <v-text-field
            v-model="contactForm.person"
            :rules="contactFormValidation.requiredRules"
            label="担当者様名"
            required
            outlined
            solo
          ></v-text-field>
          <v-text-field
            validate-on-blur="true"
            v-model="contactForm.tel"
            :rules="contactFormValidation.required_telRules"
            label="電話番号（半角数字）"
            required
            outlined
            solo
          ></v-text-field>
          <v-text-field
            validate-on-blur="true"
            v-model="contactForm.email1"
            :rules="contactFormValidation.required_emailRules"
            label="メールアドレス"
            required
            outlined
            solo
          ></v-text-field>
          <!--
          <v-textarea
            v-model="contactForm.contents"
            :rules="contactFormValidation.requiredRules"
            label="備考欄"
            required
            outlined
            solo
          ></v-textarea>
          -->
          <v-checkbox
            v-model="checkbox"
            :rules="[v => !!v || '同意しなければ送信できません。']"
            required
          >
            <div slot='label'>
              <v-dialog
                v-model="modal"
                max-width="800"
              >
                <template v-slot:activator="{on}">
                  <a v-on:click.stop.prevent v-on="on">プライバシーポリシー</a>に同意します。
                </template>
                <v-card>
                  <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                  >
                    Privacy Policy
                  </v-card-title>
                  <v-card-text>
                    <section>
                      <h4 class="section_title">プライバシーポリシー（個人情報保護方針）</h4>
                      <p>当社は、健康づくりサポートを行う企業として、受診者様、利用者様等のお客様の個人情報保護はもとより、従業者も含めた個人情報保護の重要性を十分自覚するとともに、当社の社会的責務であると認識し、以下の個人情報保護方針を実行します。</p>
                      <ol class="list_parentheses">
                        <li>お客様に関する個人情報の利用目的</li>
                        <ol class="list_children">
                          <li>個人情報の取得・利用・提供に関しては、当社で行うすべての事業で取り扱う個人情報について、その事業内容・規模にふさわしい取得目的、利用範囲を明確にし、適切に取り扱うことを規定に定め、遵守します。これには、あらかじめ明示した利用目的の達成に必要な範囲を超えた個人の取り扱いを行わないことおよびそのための措置を講じることを含みます。</li>
                          <li>個人情報の取り扱いに関する法令、国が定める指針及びその他の規範を遵守します。</li>
                          <li>個人情報の漏洩、滅失又はき損などが発生しない安全な業務体制を確立するとともに、これらのリスクに対し適切な予防措置・是正措置を講じます。</li>
                          <li>個人情報保護を確実に遵守するための個人情報保護マネジメントシステムを構築し、個人情報の適切な管理運用及びその継続的改善を図ります。</li>
                          <li>個人情報保護に関する苦情および相談に適切に対応します。</li>
                        </ol>
                      </ol>
                    </section>
                    <section>
                      <h4 class="section_title">個人情報の利用目的</h4>
                      <p>当社は、お客様の皆様並びに従業者等の個人情報を下記の目的のために利用いたします。</p>
                      <ol class="list_parentheses">
                        <li>お客様に関する個人情報の利用目的</li>
                        <ul class="ulist_children">
                          <li>各種研修、セミナー、見学会等のご案内及び運営に関する資料送付のため</li>
                          <li>お問い合わせ・ご相談への対応のため</li>
                          <li>各種調査研究実施、アンケート調査実施のため</li>
                          <li>パンフレット、資料等の配布、メールマガジン配信などの広報活動のため</li>
                          <li>契約の履行のため</li>
                          <li>見積書、請求書、納品書発行等の事業管理業務のため</li>
                          <li>支払決済業務および法定調書の作成・提出業務のため</li>
                          <li>組織変更又は異動等のご案内および時候挨拶のため</li>
                        </ul>
                        <li>採用活動関連の個人情報の利用目的</li>
                        <ul class="ulist_children">
                          <li>採用に関連する資料等作成のため</li>
                          <li>採用選考手続及びその結果に関する連絡のため</li>
                          <li>入職前手続の実施のため</li>
                        </ul>
                        <li>従業者の個人情報の利用目的</li>
                        <ul class="ulist_children">
                          <li>職員等（一部家族を含む）の雇用管理、賃金管理、健康管理、福利厚生の諸手続きを行うため</li>
                          <li>人事管理制度に基づく職員の人事管理、退職手続きを行うため</li>
                          <li>お客様、取引先等との各種連絡のため</li>
                        </ul>
                        <li>開示対象個人情報以外の個人情報の利用目的</li>
                        <ul class="ulist_children">
                          <li>企業、労働組合、健康保険組合、公的機関等のお客様から委託を受けた情報処理業務及び教育研修業務、後方業務に使用するため</li>
                          <li>企業、労働組合、健康保険組合、公的機関等のお客様から委託を受けた社員満足度調査及び意識調査に使用するため</li>
                        </ul>
                      </ol>
                    </section>
                    <section>
                      <h4 class="section_title">お問い合わせ窓口について</h4>
                      <p>
                        <span class="mgr-1">株式会社</span>オゾンヘルスケアラボラトリー<br>
                        <span class="mgr-1">個人情報保護管理者</span>代表取締役社長<br>
                        <span class="mgr-1">〒232-0004本社</span>神奈川県横浜市南区前里町1-4-3-3F<br>
                        <span class="mgr-1">TEL:045-315-6860&nbsp;平日：10:00～19:00</span>
                      </p>
                    </section>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="modal = false;"
                    >
                      閉じる
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-checkbox>
          <!--
          <v-text-field
                  v-model="contactForm.email2"
                  :rules="contactFormValidation.emailRules"
                  label="メールアドレス(確認のためもう一度入力してください)"
                  required
          ></v-text-field>
          
          <br>
          <h5>お問い合わせ内容</h5>
          <v-radio-group v-model="contactForm.inquiry">
            <v-radio 
              value="サービスを利用したい・導入を考えている" 
              label="サービスを利用したい・導入を考えている"
            ></v-radio>
            <v-radio 
              value="資料請求・詳しい内容を知りたい" 
              label="資料請求・詳しい内容を知りたい"></v-radio>
            <v-radio 
              value="その他(ご連絡欄にご記入ください)" 
              label="その他(ご連絡欄にご記入ください)"></v-radio>
          </v-radio-group>

          -->
          <v-row justify="center">
            <v-btn
              @click.stop="dialog = true"
              :loading="contactForm.loading"
              :disabled="!contactFormValidation.valid"
              large
              color="info"
              class="mt-4 font-weight-bold"
            >
              送信
            </v-btn>
            <v-dialog
              v-model="dialog"
              max-width="380"
            >
              <v-card>
                <v-card-title class="headline">現在の内容で送信しますか？</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="dialog = false"
                  >
                    戻る
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="dialog = false, sendMail()"
                  >
                    送信する
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-form>
      
      <v-snackbar
        v-model="snackBar.show"
        :color="snackBar.color"
        bottom
        right
        :timeout="6000"
        class="font-weight-bold"
      >
        {{snackBar.message}}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
  import {functions} from '@/plugins/firebase'

  export default {
    name: "contact",
    data: () => ({
      checkbox: false,
      dialog: false,
      modal: '',
      contactForm: {
        corporate: '',
        department: '',
        person: '',
        tel: '',
        email1: '',
        inquiry: '',
        contents: '',
        loading: false,
      },
      contactFormValidation: {
        valid: false,
        requiredRules: [v => !!v || '必須項目です'],
	required_telRules: [
          v => !!v || '必須項目です',
          v => /^\d{2,4}-?\d{2,4}-?\d{4}$/.test(v) || '正しい電話番号を半角数字で入力してください。',
        ],
        required_emailRules: [
          v => !!v || '必須項目です',
          v => /^([a-zA-Z0-9]+[a-zA-Z0-9._-]*)+@[a-zA-Z0-9._-]+(\.[a-zA-Z0-9._-]+)+$/.test(v) || '正しいメールアドレスを入力してください。'
        ],
        emailRules(v) {
          return v === this.email1 || '同じメールアドレスを記入してください'
        },
      },
      snackBar: {
        show: false,
        color: '',
        message: ''
      }
    }),
    methods: {
      sendMail: function () {
        if (this.$refs.form.validate()) {
          this.contactForm.loading = true
          const mailer = functions.httpsCallable('sendMail')

          mailer(this.contactForm)
            .then(() => {
              this.formReset()
              this.showSnackBar(
                'success',
                'お問い合わせありがとうございます。送信完了しました'
              )
            })
            .catch(err => {
              this.showSnackBar(
                'error',
                '送信に失敗しました。お手数ですが電話にてお問い合わせお願いいたします。'
              )
              console.log(err)
            })
            .finally(() => {
              this.contactForm.loading = false
            })
        }
      },
      showSnackBar: function (color, message) {
        this.snackBar.message = message
        this.snackBar.color = color
        this.snackBar.show = true
      },
      formReset: function () {
        this.$refs.form.reset()
      }
    }
  }
</script>

<style scoped>

  .head {
    position: relative;
    font-size: 30px;
    letter-spacing: 0.1em;
  }

  .head:before {
    content: '';
    position: absolute;
    bottom: -10px;
    display: inline-block;
    width: 350px;
    height: 1px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: black;
    border-radius: 2px;
  }
  .sub{
    color:#808080;
    font-size: 18px;
    letter-spacing: 0.1em;
  }

  section{
    padding: 1em 0 0 0;
  }

  h4.section_title{
    font-size: 1.3em;
  }

  ol.list_parentheses{
    padding:0 0 0 2em;
    margin:0;
  }

  ol.list_parentheses li{
    list-style-type:none;
    list-style-position:inside;
    counter-increment: cnt;
  }

  ol.list_parentheses li:before{
    display: marker;
    content: "(" counter(cnt) ")";
    padding-right: .5em;
    font-weight: bold;
  }

  ol.list_children{
    padding:0 0 0 2em;
    margin:0;
  }

  ol.list_children li{
    list-style-type:none;
    list-style-position:inside;
    counter-increment: children_cnt;
  }

  ol.list_children li:before{
    display: marker;
    content: counter(children_cnt)'.';
    padding-right: .5em;
    font-weight: bold;
  }

  ul.ulist_children{
    padding:0 0 0 2em;
    margin:0;
  }

  ul.ulist_children li{
    list-style-type: disc;
    counter-increment: uchildren_cnt;
  }

  ul.ulist_children li:before{
    display: marker;
    content: none;
  }

  span.mgr-1{
    margin-right: 1em;
  }

@media screen and (min-width:300px) {
    /*スマホ用です。画面サイズが480pxからはここを読み込む*/
  .form{
    width: 100%;
    margin: 0;
  }
}


@media screen and (min-width:768px){
    /*画面サイズが768pxから1024pxまではここを読み込む*/
  .form{
    width: 60%;
    margin: 32px auto;
    z-index: 90;
  }
}
</style>
